import {IDepotResUiEnv, IDepotShortResUiEnv} from "/@lib@/store/depot.js";
import {IReg, IRegPointer, REG} from "/@lib@/commons/registry.js";
import {DOMSH} from "/@lib@/commons/xml/domsh.js";
import {DOM} from "/@lib@/commons/xml/dom.js";
import {OResBodyViewInit, ResBodyView} from "/@back@/store/views/resViewer.js";
import {ActionBtn, OActionBtnInit} from "/@back@/commons/widgets/buttons.js";
import {IArea} from "/@lib@/commons/areas.js";
import {IDepotResCtx} from "/@lib@/store/res.js";
import {JNodeInfos} from "/@lib@/store/urlTree.js";
import {BASIS} from "/@back@/commons/basis.js";


export interface ResInfoView extends ResBodyView {
	initialize(init: OResInfoViewInit): this
}

export interface OResInfoViewInit extends OResBodyViewInit {
	/** Lignes constituant cette resInfoView. */
	lines: IResInfosLineDrawer[]

	/** Ligne affichée si aucne aitre n'est affichée. */
	lineIfEmpty?: IResInfosLineDrawer

	/** Ecoute les modifs du node (pas de ses voisins ch, anc, hist, succ...). */
	listenChanges?: boolean
}

/**
 * Classes :
 * 	small
 */
export class ResInfoView extends ResBodyView {

	lines: IResInfosLineDrawer[];

	lineIfEmpty: IResInfosLineDrawer;

	protected _initialize(init: OResInfoViewInit) {
		this.reg = init.areaContext.reg;
		super._initialize(init); //init this.area, this.areaContext
		const sr = this.attachShadow(DOMSH.SHADOWDOM_INIT);
		this.reg.installSkin('form-control-areas', sr);
		this._initAndInstallSkin(this.localName, init);

		if (init.listenChanges) (this.reg.env as IDepotResUiEnv).nodeInfosChange?.on("nodeChange", this.refresh.bind(this));
		this.lines = init.lines;
		this.lineIfEmpty = init.lineIfEmpty;
	}

	private _pendingDraw: number | undefined;
	protected async draw() {
		const sr = this.shadowRoot;
		BASIS.clearContent(sr);

		const currentRefresh = this._pendingDraw = Date.now();

		const resPath = this.reg.env.path;
		let hasDrawnLine = false;

		const hasRequiredMetas = this.lines.find(entry => entry.requiredMetas) ? true : false;
		if (hasRequiredMetas && !(this.reg.env.nodeInfos as JNodeInfos).metas)
			this.reg = this.reg.env.universe.newDepotResUiRegFromDepotUiReg(this.reg, resPath, true);

		while ((this.reg.env as IDepotResUiEnv).nodeInfosPending) await (this.reg.env as IDepotResUiEnv).nodeInfosPending;

		if (currentRefresh !== this._pendingDraw) return;//raceCond
		if (this.reg.isClosed) return;

		const ctx: IDepotResCtx = {
			reg: this.reg,
			emitter: this,
		};
		for (let line of this.lines) {
			if (line.drawLine(ctx, sr, this) !== false)
				hasDrawnLine = true;
		}
		if (!hasDrawnLine && this.lineIfEmpty)
			this.lineIfEmpty.drawLine(ctx, sr, this)
	}
}

export interface IResInfosLineDrawer {
	/** Retourne false si la ligne n'a pas été dessinée */
	drawLine(ctx: IRegPointer<IDepotResUiEnv | IDepotShortResUiEnv>, parent: Node, view: ResBodyView): false | void

	/** true si les metas doivent etre présentes dans l'infoRes pour affichage correct de cette ligne  */
	requiredMetas?: boolean
}

REG.reg.registerSkin('store-res-infos', 1, /* language=CSS */ `
	:host {
		display: grid;
		grid-template-columns: auto 1fr;
		grid-column-gap: .5rem;
		grid-auto-rows: max-content;
	}

	:host(:not(.small)) {
		grid-row-gap: .5rem;
		padding: .5rem;
	}

	/** class 'ctrlLbl' : Compat form-control-areas */
	.line, .ctrlLbl {
		display: contents;
	}

	/** class 'lbl' : Compat form-control-areas */
	.label, .lbl {
		display: flex;
		color: var(--alt1-color);
		justify-content: flex-end;
	}

	:host(.small) .label, :host(.small) .lbl {
		color: unset;
	}

	/** class 'lbl' : Compat form-control-areas */
	.lbl {
		margin-inline-end: unset;
	}

	:host(:not(.small)) .value {
		font-weight: bold;
	}

	.valueEntry {
		display: inline-block;
	}

	.cplt {
		font-style: italic;
	}

	:any-link {
		color: unset;
	}
`);

customElements.define('store-res-infos', ResInfoView);


/**
 * Bouton dont l'affichage est une ResView
 */
export interface OResViewActBtnInit<C> extends OActionBtnInit<C> {
	resView: IArea<IRegPointer<IDepotResUiEnv>>
	reg: IReg<IDepotResUiEnv>
}

export class ResViewActBtn extends ActionBtn<IRegPointer<IDepotResUiEnv>> {

	reg: IReg<IDepotResUiEnv>

	protected resView: IArea<IRegPointer<IDepotResUiEnv>>

	protected _initialize(init: OResViewActBtnInit<IRegPointer<IDepotResUiEnv>>) {
		super._initialize(init);
		this.reg = this.findReg(init);
		this.resView = init.resView;
	}

	get icon(): string {
		return null;
	}

	get label(): string {
		return null;
	}

	protected _refresh() {
		super._refresh();
		if (!this._labelElt) this._createLabel();
		DOM.setHidden(this._labelElt, false);
		this.resView.loadBody(this).then((elt) => {
			this._labelElt.innerHTML = "";
			this._labelElt.appendChild(elt);
		})
	}

}

customElements.define('store-res-btn-resview', ResViewActBtn);